"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Clickable = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../theme/utils/useTheme");
var _createFocusRingStyles = require("../../util/createFocusRingStyles");
var _ClickableStyled = require("./styled/ClickableStyled");
var _clickableTheme = require("./styled/clickableTheme");
/**
 * Provides the basic stuff for any clickables, include a style reset!
 */
const Clickable = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children,
    clientId,
    omitFocusRing = false,
    focusRingOptions = {},
    isDisabled = false,
    onClick: providedOnClick,
    onDoubleClick: providedOnDoubleClick,
    tabIndex = 0,
    type = "button",
    ...rest
  } = _ref;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const onClick = (0, _react.useCallback)(e => {
    if (isDisabled) {
      e.preventDefault();
      return;
    }
    if (providedOnClick) {
      providedOnClick(e);
    }
  }, [isDisabled, providedOnClick]);
  const onDoubleClick = (0, _react.useCallback)(e => {
    if (isDisabled) {
      e.preventDefault();
      return;
    }
    if (providedOnDoubleClick) {
      providedOnDoubleClick(e);
    }
  }, [isDisabled, providedOnDoubleClick]);
  const {
    offset,
    includeFocusPseudoClass,
    borderWidth,
    radius,
    ...restFocusRingOptions
  } = focusRingOptions;
  const focusRingStyles = (0, _react.useMemo)(() => omitFocusRing ? "" : (0, _createFocusRingStyles.createFocusRingStyles)({
    theme: themeMode,
    gap: offset ?? 1,
    componentRadius: radius ?? _clickableTheme.clickableTheme.borderRadius(themeMode),
    componentBorderWidth: borderWidth ?? 1,
    focusSelector: includeFocusPseudoClass ? ":focus" : undefined,
    ringWidth: borderWidth ?? undefined,
    ...restFocusRingOptions
  }),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [omitFocusRing, ...Object.values(focusRingOptions)]);
  return /*#__PURE__*/_react.default.createElement(_ClickableStyled.ClickableStyled, (0, _extends2.default)({}, rest, {
    isDisabled: isDisabled,
    "aria-disabled": isDisabled,
    "data-client-id": clientId,
    focusRingStyles: focusRingStyles,
    ref: ref,
    onClick: onClick,
    onDoubleClick: onDoubleClick,
    tabIndex: tabIndex,
    type: type
  }), children);
});
exports.Clickable = Clickable;
Clickable.displayName = "Clickable";
//# sourceMappingURL=Clickable.js.map